<template>
  <div>
    <el-form :model="form" ref="ruleForm" label-width="120px">

      <!--      <el-form-item required label="名称">-->
      <!--        <el-input v-model="form.name"></el-input>-->
      <!--      </el-form-item>-->
      <el-form-item required label="联系人">
        <el-input v-model="form.username" placeholder="联系人手机号"></el-input>
      </el-form-item>

      <!--      <el-form-item required label="联系电话">-->
      <!--        <el-input v-model="form.phone" maxlength="11"></el-input>-->
      <!--      </el-form-item>-->

      <el-form-item required label="管理员账号">
        <el-input v-model="form.adminphone" placeholder="管理员手机号" maxlength="11"></el-input>
      </el-form-item>

      <!--      <el-form-item required label="授权人数">-->

      <!--        <el-input type="number" v-model="form.peopleNumber"></el-input>-->
      <!--      </el-form-item>-->
      <el-form-item required label="授权时间">


        <el-date-picker

          v-model="form.time"
          align="right"
          type="date"
          placeholder="选择日期"
          :picker-options="pickerOptions">
        </el-date-picker>

      </el-form-item>

      <el-form-item label="备注">

        <el-input type="textarea" v-model="form.desc"></el-input>
      </el-form-item>


      <el-form-item size="large">
        <el-button type="primary" @click="onSubmit">{{ btn_msg }}</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>

    </el-form>

  </div>
</template>

<script>

import u from "../../../assets/js/util";


export default {
  name: "add_users",
  props: ["editInfo"],
  data() {
    return {
      btn_msg: "新增",
      form: {
        username: "",
        adminphone: "",
        peopleNumber: "",
        time: "",
        desc: "",
      },

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '一年',
          onClick(picker) {
            const date = new Date();
            date.setTime(new Date().getTime() + 1000 * 60 * 60 * 24 * 365);
            picker.$emit('pick', date);
          }
        }, {
          text: '两年',
          onClick(picker) {
            const date = new Date();
            date.setTime(new Date().getTime() + 1000 * 60 * 60 * 24 * 365 * 2);
            picker.$emit('pick', date);
          }
        }, {
          text: '三年',
          onClick(picker) {
            const date = new Date();
            date.setTime(new Date().getTime() + 1000 * 60 * 60 * 24 * 365 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '五年',
          onClick(picker) {
            const date = new Date();
            date.setTime(new Date().getTime() + 1000 * 60 * 60 * 24 * 365 * 5);
            picker.$emit('pick', date);
          }
        }
        ]
      }
    }
  },
  async mounted() {
    if (this.editInfo._id) {
      this.form = JSON.parse(JSON.stringify(this.editInfo))
      this.btn_msg = "修改"
    }
  },
  methods: {

    close() {
      this.$emit("close")
    },
    async onSubmit(e) {


      var from = this.form

      if (!from.username) {
        u.error("名称不能空")
        return
      }

      if (!from.adminphone) {
        u.error("管理员账号不能空")
        return
      }
      if (!u.isPhone(from.adminphone)) {
        u.error("管理员账号格式不正确")
        return
      }


      if (!from.time) {
        u.error("授权时长不能空")
        return
      }
      if (from._id) {

        var id = this.form._id

        delete this.form._id

        var status = await u.post("users", "account_update", {
          "table": "enterprise",
          where: {_id: id},
          data: this.form,
        })
        if (status !== false) {

          this.$emit("success", "")
        }

        return
      } else {
        var account = await u.post("users", "account_list_add", {adminphone: from.adminphone, name: from.name, phone: from.phone})


        if (account === false) {
          return

        }
        if (account[1] > 0) {
          u.error("联系人手机号、公司名称、管理员账号已经存在")
          return
        }


        var status = await u.post("users", "account_add", {
          "table": "enterprise",
          data: this.form,
        })
        if (status !== false) {

          this.$emit("success", "")
        }

      }

    }
  }
}
</script>


<style scoped>
.el-textarea, .el-input {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/module/admin/add_users.vue